import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Pagination, Scrollbar, Loading, Select, Option, Form, FormItem, Input, DatePicker ,Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
// import './registerServiceWorker'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import sa from 'sa-sdk-javascript'
import Log from './util/log'
import './components/index.js'
import './util/polyfill'
import 'babel-polyfill'
import { loginIn } from './util/auth'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import common from '@/util/common.js' // 自定义挂载到vue实例上的通用属性或func
import './util/samixin'

import config from './../config/index'
//var config = require('./../config')
import 'normalize.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/common.less'
import './assets/el-theme.scss'

// 注册全局过滤器
import * as filters from '@/util/filter.js'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.env = window.$config.env

Vue.use(VueCookies)
  .use(VueAxios, axios)
  .use(Pagination)
  .use(Select)
  .use(Option)
  .use(Form)
  .use(FormItem)
  .use(Input)
  .use(DatePicker)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(common)
  .use(Scrollbar)
  .use(Loading)
  .use(VueAwesomeSwiper)

Vue.config.productionTip = false
axios.defaults.baseURL = window.$config.apiURL;

let regExp = new RegExp('"', 'g');

if (VueCookies.get('Authorization')) {
  axios.defaults.headers['Authorization'] = VueCookies.get('Authorization').replace(regExp, '');
}
axios.defaults.headers['vk-source'] = "vkshop-pc"

axios.interceptors.response.use(response => {
  var codeArr = [1002, 1003, 1004, 1005, 1006, 1009]
  if (response.data && codeArr.indexOf(response.data.code) > -1) {
    loginIn()
  }

  if (response.data && ![3005, 3040, 3042].includes(response.data.code) && response.data.code > 3000 && response.data.code < 4000) {
    router.push({
      path: '/error/500',
      query: {
        msg: response.data.msg
      }
    })
  }

  return response;
}, error => {
  //  用户未认证
  if (error.response.status === 401) {
    loginIn()
    return
  }
  // router.push({
  //   path: '/error/500',
  //   query: {
  //     msg: '该页面丢失了'
  //   }
  // })
});




// 神策埋点
const user_id = VueCookies.get('studentId')
sa.init({
  server_url: window.$config.saServer_url,
  heatmap_url: 'http://static.sensorsdata.cn/sdk/1.12.3/heatmap.min.js',
  show_log: false,
  heatmap: {
    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'not_collect',
    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
    scroll_notice_map: 'not_collect'
  }
});
sa.login(user_id);
router.afterEach((to, from, next) => {
  const channel_id = VueCookies.get('channel_id')
  Vue.nextTick(() => {
    // 如果有channelId，访问的时候，带上这个参数
    sa.quick("autoTrackSinglePage", { channel_id: channel_id });
    // 渠道，将activityCode通过url带到电商，通过session存储，然后注册的时候带到注册页
    let code = to.query.activity_code
    if (code) {
      sessionStorage.setItem('code', code)
    }
    let channelId = to.query.channel_id
    if (channelId) {
      sessionStorage.setItem('channelId', channelId)
    }
  })
})
// 点击事件统计
Log.init()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')